// Generated by scripts/generate-connect-problems.mjs. Do not edit directly.
export const CONNECT_PROBLEM_VERSION = 1;
export const CONNECT_PROBLEM_CATALOG = {
    "access_denied": { category: "authorization", recovery: "reauthorize" },
    "access_paused": { category: "availability", recovery: "resume_connector_access" },
    "application_declaration_mismatch": { category: "authorization", recovery: "reauthorize" },
    "application_identity_unavailable": { category: "compatibility", recovery: "upgrade_application" },
    "approval_window_blocked": { category: "authorization", recovery: "reauthorize" },
    "authority_authorization_changed": { category: "authorization", recovery: "reauthorize" },
    "authorization_binding_incompatible": { category: "compatibility", recovery: "upgrade_application" },
    "authorization_cancelled": { category: "cancellation", recovery: "none" },
    "authorization_expired": { category: "authorization", recovery: "reauthorize" },
    "authorization_replayed": { category: "integrity", recovery: "reauthorize" },
    "browser_required": { category: "compatibility", recovery: "none" },
    "callback_url_required": { category: "validation", recovery: "fix_request" },
    "capability_contract_incompatible": { category: "compatibility", recovery: "upgrade_application" },
    "change_cursor_reset": { category: "conflict", recovery: "refresh" },
    "collection_access_denied": { category: "authorization", recovery: "reauthorize" },
    "collection_configuration_invalid": { category: "validation", recovery: "repair_collection" },
    "collection_contracts_missing": { category: "compatibility", recovery: "choose_collection" },
    "collection_incompatible": { category: "compatibility", recovery: "choose_collection" },
    "collection_invalid": { category: "validation", recovery: "repair_collection" },
    "collection_kind_unsupported": { category: "compatibility", recovery: "choose_collection" },
    "collection_mismatch": { category: "selection", recovery: "choose_collection" },
    "collection_not_found": { category: "selection", recovery: "choose_collection" },
    "collection_not_ready": { category: "selection", recovery: "choose_collection" },
    "collection_not_selected": { category: "selection", recovery: "choose_collection" },
    "collection_type_registry_invalid": { category: "validation", recovery: "repair_collection" },
    "collection_version_unsupported": { category: "compatibility", recovery: "upgrade_collection" },
    "concurrent_modification": { category: "conflict", recovery: "refresh" },
    "connector_busy": { category: "availability", recovery: "retry" },
    "connector_identity_changed": { category: "integrity", recovery: "reauthorize" },
    "connector_offline": { category: "availability", recovery: "retry" },
    "connector_upgrade_required": { category: "compatibility", recovery: "upgrade_connector" },
    "cursor_capacity_exhausted": { category: "availability", recovery: "retry" },
    "device_authorization_failed": { category: "authorization", recovery: "reauthorize" },
    "direct_operation_rejected": { category: "authorization", recovery: "reauthorize" },
    "discovery_failed": { category: "availability", recovery: "retry" },
    "durable_mutation_unsupported": { category: "compatibility", recovery: "upgrade_connector" },
    "encrypted_relay_rejected": { category: "authorization", recovery: "reauthorize" },
    "encryption_required": { category: "authorization", recovery: "reauthorize" },
    "expired_token": { category: "authorization", recovery: "reauthorize" },
    "file_changed_during_move": { category: "conflict", recovery: "refresh" },
    "file_changed_during_read": { category: "conflict", recovery: "refresh" },
    "file_index_warming": { category: "availability", recovery: "retry" },
    "file_move_failed": { category: "internal", recovery: "contact_support" },
    "file_mutation_conflict": { category: "conflict", recovery: "resolve_conflict" },
    "file_not_found": { category: "conflict", recovery: "refresh" },
    "file_source_mismatch": { category: "conflict", recovery: "refresh" },
    "file_upload_incomplete": { category: "conflict", recovery: "retry" },
    "fresh_request_required": { category: "availability", recovery: "retry" },
    "generation_expired": { category: "conflict", recovery: "refresh" },
    "hosted_provider_unavailable": { category: "availability", recovery: "retry" },
    "insufficient_access": { category: "authorization", recovery: "reauthorize" },
    "invalid_application_authorization": { category: "validation", recovery: "fix_request" },
    "invalid_application_manifest": { category: "validation", recovery: "fix_request" },
    "invalid_callback": { category: "validation", recovery: "fix_request" },
    "invalid_device_authorization_response": { category: "integrity", recovery: "contact_support" },
    "invalid_encrypted_response": { category: "integrity", recovery: "contact_support" },
    "invalid_loopback_url": { category: "validation", recovery: "fix_request" },
    "invalid_mutation_id": { category: "validation", recovery: "fix_request" },
    "invalid_operation_response": { category: "integrity", recovery: "contact_support" },
    "invalid_path": { category: "validation", recovery: "fix_request" },
    "invalid_preflight": { category: "conflict", recovery: "refresh" },
    "invalid_push_payload": { category: "validation", recovery: "fix_request" },
    "invalid_push_subscription": { category: "validation", recovery: "fix_request" },
    "invalid_read_cursor": { category: "validation", recovery: "fix_request" },
    "invalid_request": { category: "validation", recovery: "fix_request" },
    "invalid_token_response": { category: "integrity", recovery: "contact_support" },
    "managed_fcm_not_declared": { category: "compatibility", recovery: "fix_request" },
    "manifest_load_failed": { category: "availability", recovery: "retry" },
    "manifest_required": { category: "validation", recovery: "fix_request" },
    "missing_grant_key": { category: "authorization", recovery: "reauthorize" },
    "mutation_recovery_expired": { category: "compatibility", recovery: "none" },
    "mutation_request_conflict": { category: "conflict", recovery: "resolve_conflict" },
    "no_pending_mutation": { category: "conflict", recovery: "refresh" },
    "not_authorized": { category: "authorization", recovery: "reauthorize" },
    "not_remote_authority": { category: "compatibility", recovery: "choose_collection" },
    "notification_criterion_not_declared": { category: "validation", recovery: "fix_request" },
    "notification_reauthorization_required": { category: "authorization", recovery: "reauthorize" },
    "notification_registration_failed": { category: "availability", recovery: "retry" },
    "notification_unregistration_failed": { category: "availability", recovery: "retry" },
    "notifications_not_declared": { category: "compatibility", recovery: "fix_request" },
    "notifications_unavailable": { category: "availability", recovery: "retry" },
    "operation_cancelled": { category: "cancellation", recovery: "none" },
    "operation_failed": { category: "internal", recovery: "contact_support" },
    "operation_invalid": { category: "validation", recovery: "fix_request" },
    "operation_outcome_unknown": { category: "conflict", recovery: "resolve_outcome" },
    "path_occupied": { category: "conflict", recovery: "resolve_conflict" },
    "pending_mutation_unresolved": { category: "conflict", recovery: "resolve_outcome" },
    "query_snapshot_changed": { category: "conflict", recovery: "refresh" },
    "rate_limited": { category: "availability", recovery: "retry" },
    "reconnect_required": { category: "authorization", recovery: "reauthorize" },
    "redirect_uri_required": { category: "validation", recovery: "fix_request" },
    "reference_updates_unsupported": { category: "compatibility", recovery: "fix_request" },
    "registry_backup_invalid": { category: "integrity", recovery: "contact_support" },
    "registry_busy": { category: "availability", recovery: "retry" },
    "registry_corrupt": { category: "integrity", recovery: "repair_collection" },
    "registry_migration_failed": { category: "internal", recovery: "contact_support" },
    "registry_schema_incompatible": { category: "compatibility", recovery: "upgrade_connector" },
    "relay_authorization_expired": { category: "authorization", recovery: "reauthorize" },
    "relay_unavailable": { category: "availability", recovery: "retry" },
    "sandbox_unsupported": { category: "compatibility", recovery: "fix_request" },
    "scope_denied": { category: "authorization", recovery: "reauthorize" },
    "session_destroyed": { category: "cancellation", recovery: "none" },
    "session_not_started": { category: "validation", recovery: "fix_request" },
    "session_starting": { category: "availability", recovery: "retry" },
    "stale_file_revision": { category: "conflict", recovery: "refresh" },
    "storage_required": { category: "compatibility", recovery: "none" },
    "sync_failed": { category: "availability", recovery: "retry" },
    "temporarily_unavailable": { category: "availability", recovery: "retry" },
    "timeout": { category: "availability", recovery: "retry" },
    "token_exchange_failed": { category: "availability", recovery: "retry" },
    "transport_protocol_incompatible": { category: "compatibility", recovery: "upgrade_connector" },
    "type_pack_provision_failed": { category: "validation", recovery: "repair_collection" },
    "unknown_collection": { category: "selection", recovery: "choose_collection" },
    "unsafe_file_path": { category: "validation", recovery: "fix_request" },
    "unsupported_encryption": { category: "compatibility", recovery: "upgrade_application" },
    "unsupported_operation": { category: "compatibility", recovery: "fix_request" }
};
const CONNECT_PROBLEM_DETAIL_SCHEMAS = {
    "access_denied": {
        "type": "object",
        "required": [],
        "properties": {
            "return_to": {
                "type": "string"
            }
        }
    },
    "approval_window_blocked": {
        "type": "object",
        "required": [
            "user_code",
            "verification_uri",
            "verification_uri_complete",
            "expires_at",
            "interval_seconds"
        ],
        "properties": {
            "user_code": {
                "type": "string"
            },
            "verification_uri": {
                "type": "string"
            },
            "verification_uri_complete": {
                "type": "string"
            },
            "expires_at": {
                "type": "integer"
            },
            "interval_seconds": {
                "type": "integer"
            }
        }
    },
    "authorization_binding_incompatible": {
        "type": "object",
        "required": [
            "contract",
            "required",
            "supported",
            "peer"
        ],
        "properties": {
            "contract": {
                "type": "string"
            },
            "required": {
                "type": "array",
                "items": {
                    "type": "integer"
                }
            },
            "supported": {
                "type": "array",
                "items": {
                    "type": "integer"
                }
            },
            "peer": {
                "type": "string"
            },
            "operation": {
                "type": "string"
            }
        }
    },
    "capability_contract_incompatible": {
        "type": "object",
        "required": [
            "contract",
            "required",
            "supported",
            "peer"
        ],
        "properties": {
            "contract": {
                "type": "string"
            },
            "required": {
                "type": "array",
                "items": {
                    "type": "integer"
                }
            },
            "supported": {
                "type": "array",
                "items": {
                    "type": "integer"
                }
            },
            "peer": {
                "type": "string"
            },
            "operation": {
                "type": "string"
            }
        }
    },
    "collection_configuration_invalid": {
        "type": "object",
        "required": [
            "diagnostics"
        ],
        "properties": {
            "diagnostics": {
                "type": "array",
                "items": {
                    "type": "object"
                }
            }
        }
    },
    "collection_contracts_missing": {
        "type": "object",
        "required": [
            "contracts"
        ],
        "properties": {
            "contracts": {
                "type": "array",
                "items": {
                    "type": "object",
                    "required": [
                        "id",
                        "version"
                    ],
                    "properties": {
                        "id": {
                            "type": "string"
                        },
                        "version": {
                            "type": "string"
                        }
                    }
                }
            }
        }
    },
    "collection_invalid": {
        "type": "object",
        "required": [
            "diagnostics"
        ],
        "properties": {
            "diagnostics": {
                "type": "array",
                "items": {
                    "type": "object"
                }
            }
        }
    },
    "collection_type_registry_invalid": {
        "type": "object",
        "required": [
            "diagnostics"
        ],
        "properties": {
            "diagnostics": {
                "type": "array",
                "items": {
                    "type": "object"
                }
            }
        }
    },
    "collection_version_unsupported": {
        "type": "object",
        "required": [
            "current_version",
            "required_version"
        ],
        "properties": {
            "current_version": {
                "type": "string"
            },
            "required_version": {
                "type": "string"
            }
        }
    },
    "connector_offline": {
        "type": "object",
        "required": [],
        "properties": {
            "connector_name": {
                "type": "string"
            }
        }
    },
    "durable_mutation_unsupported": {
        "type": "object",
        "required": [
            "contract",
            "required",
            "supported",
            "peer"
        ],
        "properties": {
            "contract": {
                "type": "string"
            },
            "required": {
                "type": "array",
                "items": {
                    "type": "integer"
                }
            },
            "supported": {
                "type": "array",
                "items": {
                    "type": "integer"
                }
            },
            "peer": {
                "type": "string"
            },
            "operation": {
                "type": "string"
            }
        }
    },
    "insufficient_access": {
        "type": "object",
        "required": [
            "required_operations",
            "granted_operations",
            "missing_operations"
        ],
        "properties": {
            "required_operations": {
                "type": "array",
                "items": {
                    "type": "string"
                }
            },
            "granted_operations": {
                "type": "array",
                "items": {
                    "type": "string"
                }
            },
            "missing_operations": {
                "type": "array",
                "items": {
                    "type": "string"
                }
            }
        }
    },
    "invalid_application_manifest": {
        "type": "object",
        "required": [
            "issues"
        ],
        "properties": {
            "issues": {
                "type": "array",
                "items": {
                    "type": "object",
                    "required": [
                        "path",
                        "keyword",
                        "message",
                        "params"
                    ],
                    "properties": {
                        "path": {
                            "type": "string"
                        },
                        "keyword": {
                            "type": "string"
                        },
                        "message": {
                            "type": "string"
                        },
                        "params": {
                            "type": "object"
                        }
                    }
                }
            }
        }
    },
    "mutation_request_conflict": {
        "type": "object",
        "required": [
            "request_id"
        ],
        "properties": {
            "request_id": {
                "type": "string"
            }
        }
    },
    "operation_invalid": {
        "type": "object",
        "required": [
            "diagnostics"
        ],
        "properties": {
            "diagnostics": {
                "type": "array",
                "items": {
                    "type": "object"
                }
            },
            "partial_result": {}
        }
    },
    "operation_outcome_unknown": {
        "type": "object",
        "required": [
            "request_id"
        ],
        "properties": {
            "request_id": {
                "type": "string"
            }
        }
    },
    "rate_limited": {
        "type": "object",
        "required": [],
        "properties": {
            "retry_after_ms": {
                "type": "integer"
            }
        }
    },
    "transport_protocol_incompatible": {
        "type": "object",
        "required": [
            "contract",
            "required",
            "supported",
            "peer"
        ],
        "properties": {
            "contract": {
                "type": "string"
            },
            "required": {
                "type": "array",
                "items": {
                    "type": "integer"
                }
            },
            "supported": {
                "type": "array",
                "items": {
                    "type": "integer"
                }
            },
            "peer": {
                "type": "string"
            },
            "operation": {
                "type": "string"
            }
        }
    }
};
export function isConnectProblemCode(code) {
    return Object.hasOwn(CONNECT_PROBLEM_CATALOG, code);
}
export function isConnectProblem(value) {
    if (!isPlainObject(value))
        return false;
    const candidate = value;
    if (candidate.problem_version !== CONNECT_PROBLEM_VERSION || typeof candidate.message !== "string" || candidate.message.length === 0)
        return false;
    if (candidate.operation_outcome !== undefined && candidate.operation_outcome !== "not_sent" && candidate.operation_outcome !== "rejected" && candidate.operation_outcome !== "unknown")
        return false;
    if (candidate.trace_id !== undefined && (typeof candidate.trace_id !== "string" || candidate.trace_id.length === 0))
        return false;
    if (candidate.code === "unknown") {
        return typeof candidate.server_code === "string"
            && candidate.server_code.length > 0
            && candidate.category === "unknown"
            && candidate.recovery === "none";
    }
    if (typeof candidate.code !== "string" || !isConnectProblemCode(candidate.code) || candidate.server_code !== undefined)
        return false;
    const definition = CONNECT_PROBLEM_CATALOG[candidate.code];
    const detailsSchema = CONNECT_PROBLEM_DETAIL_SCHEMAS[candidate.code];
    const detailsMatch = detailsSchema === undefined
        ? candidate.details === undefined
        : candidate.details === undefined
            ? (detailsSchema.required?.length ?? 0) === 0
            : matchesDetailSchema(candidate.details, detailsSchema);
    return candidate.category === definition.category
        && candidate.recovery === definition.recovery
        && detailsMatch;
}
function matchesDetailSchema(value, schema) {
    if (schema.type === undefined)
        return true;
    if (schema.type === "string")
        return typeof value === "string";
    if (schema.type === "integer")
        return typeof value === "number" && Number.isInteger(value);
    if (schema.type === "number")
        return typeof value === "number" && Number.isFinite(value);
    if (schema.type === "boolean")
        return typeof value === "boolean";
    if (schema.type === "array")
        return Array.isArray(value) && value.every((item) => matchesDetailSchema(item, schema.items ?? {}));
    if (!isPlainObject(value))
        return false;
    if (!schema.properties)
        return true;
    const candidate = value;
    if (!Object.keys(candidate).every((key) => Object.hasOwn(schema.properties, key)))
        return false;
    if (!(schema.required ?? []).every((key) => Object.hasOwn(candidate, key)))
        return false;
    return Object.entries(candidate).every(([key, item]) => matchesDetailSchema(item, schema.properties[key]));
}
function isPlainObject(value) {
    return value !== null && typeof value === "object" && !Array.isArray(value);
}
export function normalizeConnectProblem(serverCode, message, options = {}) {
    if (isConnectProblemCode(serverCode)) {
        const definition = CONNECT_PROBLEM_CATALOG[serverCode];
        const candidate = {
            problem_version: CONNECT_PROBLEM_VERSION,
            code: serverCode,
            category: definition.category,
            recovery: definition.recovery,
            message,
            ...(options.details === undefined ? {} : { details: options.details }),
            ...(options.operation_outcome === undefined ? {} : { operation_outcome: options.operation_outcome }),
            ...(options.trace_id === undefined ? {} : { trace_id: options.trace_id })
        };
        if (isConnectProblem(candidate))
            return candidate;
    }
    return {
        problem_version: CONNECT_PROBLEM_VERSION,
        code: "unknown",
        server_code: serverCode,
        category: "unknown",
        recovery: "none",
        message,
        ...(options.details === undefined ? {} : { details: options.details }),
        ...(options.operation_outcome === undefined ? {} : { operation_outcome: options.operation_outcome }),
        ...(options.trace_id === undefined ? {} : { trace_id: options.trace_id })
    };
}
